import * as M from '@mui/material';
import { useTheme } from '@mui/material/styles';
import _ from 'lodash';

import colors from '../../themes/colors';

const Button = M.styled(M.Button)(({ theme }) => ({
  paddingLeft: '16px',
  paddingRight: '16px',
  paddingTop: '8px',
  paddingBottom: '8px',
  lineHeight: '1.3em',
}));

const primaryColors = {
  ...colors,
  primary: colors,
};

export default function AxlButton(props) {
  const { icon, tooltip, spacing = 1, padding, noRadius, color, bgcolor, bg, loading = false, style, opacity = 1, minWidth, compact, ...cloneProps } = props;
  const resolvedBgColor = bgcolor || bg;
  const theme = useTheme();
  const resolvedColor = _.get(primaryColors, color) || _.get(primaryColors, resolvedBgColor) || 'inherit';
  const customizeStyle = {
    padding: padding || '8px',
    color: resolvedColor,
    backgroundColor: _.get(primaryColors, resolvedBgColor) || 'inherit',
    opacity,
    ...(noRadius ? { borderRadius: 0 } : {}),
    ...(props.variant === 'outlined'
      ? {
          border: `1px solid ${resolvedColor}`,
        }
      : {}),
    ...(icon
      ? {
          minWidth: 'auto',
          position: 'relative',
          padding: padding || '8px 10px',
        }
      : { minWidth: minWidth || 80 }),
    ...style,
  };

  return (
    <M.Box m={spacing}>
      {props.tooltip ? (
        <M.Tooltip style={{ minWidth: icon ? 'auto' : 80 }} {...tooltip}>
          <Button style={customizeStyle} {...cloneProps}>
            {loading ? <M.CircularProgress style={{ color: resolvedColor }} size={15} thickness={2} /> : cloneProps.children}
          </Button>
        </M.Tooltip>
      ) : (
        <Button style={customizeStyle} {...cloneProps}>
          {loading ? <M.CircularProgress style={{ color: resolvedColor }} size={15} thickness={2} /> : cloneProps.children}
        </Button>
      )}
    </M.Box>
  );
}
